export default __webpack_public_path__ + "static/media/vpNatural.7340cd90.svg";